export const cardHasField = (card) =>
  Boolean(
    card?.items?.some((item) => item?.item_type === 'field')
  )

export const getCardsWithoutFields = (cards = []) =>
  cards.filter((card) => !cardHasField(card))
